export const TimeModalContent = {
  DoneBtn: 'done-btn',
  CancelBtn: 'cancel-btn',
} as const;
